import React from 'react';
import {connect} from "react-redux";
import {hashHistory} from "react-router";
import {FormattedMessage} from "react-intl";

import Analytics from './../../analytics';
import {INITIAL_FLOW_BUTTON_TYPES} from "../../reducers/initialFlowReducer";
import {setInitialFlowType} from "../../actions/initialFlowFunctions";

class ChangeRoomButton extends React.Component {

  handleAddRoomClick = () => {
    Analytics.sendClickEvent("add-a-room-clicked");
    this.props.setInitialFlowType(INITIAL_FLOW_BUTTON_TYPES.Quote);
    hashHistory.push('/room');
  };

  render() {
    return (
      <div className="scart-block scart-block__add-room">
        <button className="ui-button3 ui-button3--room" onClick={this.handleAddRoomClick}>
          <FormattedMessage id="shoppingCart.changeRoomButton"/>
        </button>
      </div>
    );
  }
}

const mapStateToProps = (store) => {
  return {
    cartItems: store.cartState.cartItems,
  };
};

export default connect(mapStateToProps, {
  setInitialFlowType
})(ChangeRoomButton);
